export default __webpack_public_path__ + "static/media/8.533f6db8.png";